import { sha256 } from 'js-sha256'
let ajaxTool = {
  setting: {
    method: 'get',
    url: location.href,
    data: '',
    mimeType: 'application/x-www-form-urlencoded',
    callback: function () { },
  },
  ajax: function (json) {
    //初始化数据
    this.extend(this.setting, json)

    //创建一个xhr对象
    var xhr = new XMLHttpRequest()

    //格式化数据格式 以字符串键值队的形式传递数据
    this.setting.data = this.format(this.setting.data, this.setting.mimeType)
    //发送请求
    if (this.setting.method == 'get') {
      this.setting.url += '?' + this.setting.data
      this.setting.data = null
    }

    xhr.open(this.setting.method, this.setting.url, true)

    if (this.setting.method == 'post') {
      if (json.content_type) {
        xhr.setRequestHeader('Content-Type', 'application/json') //'application/x-www-form-urlencoded'
      }
    }

    //发送请求

    xhr.send(this.setting.data)

    //监听请求状态
    let that = this
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        let result = JSON.stringify(xhr.responseText) //假设请求的是json文件
        result = JSON.parse(result)
        that.setting.callback(result)
      }
    }
  },
  extend: function (obj1, obj2) {
    for (var attr in obj2) {
      obj1[attr] = obj2[attr]
    }
  },
  format: function (data, mimeType) {
    var html = ''
    if (mimeType === 'application/x-www-form-urlencoded') {
      for (var attr in data) {
        html += attr + '=' + data[attr] + '&'
      }
      html = html.substring(0, html.length - 1)
    } else if (mimeType === 'application/json') {
      html = JSON.stringify(data)
    }

    return html
  },
}
const CONSTS_OSTYPES = {
  Android: '2',
  IOS: '1',
  Unknown: '3', //pc
}
const supportSendBeacon = typeof navigator.sendBeacon === 'function';
export const H5Tracer = {
  supportSendBeacon,
  uaObj: {
    appName: '',
    osType: '',
    osVersion: '',
    appVersion: '',
  },
  staticData: {
    country: '',
    language: '',
  },
  init() {
    console.log('init')
    let dtStr = String(Date.now())
    if (!localStorage.dot_deviceId) {
      let idStr = dtStr + Math.floor(Math.random() * 1000)
      localStorage.dot_deviceId = 'dId.' + idStr
      localStorage.dot_userId = idStr
      // localStorage.sessionId = 'sId.' + idStr
    }

    // this.uaObj.appName = navigator.appName
    // this.uaObj.appVersion = navigator.appVersion

    let matches = navigator.userAgent.match(
      /Android [^)^;]{1,}|OS [^)^;]{1,}|NT [^)^;]{1,}/
    )
    if (matches && matches[0]) {
      // this.uaObj.osType = String(matches[0]).split(' ')[0]
      // this.uaObj.osVersion = String(matches[0])

      let osName = matches[0].split(' ')[0]
      if (osName.indexOf('Android') > -1) {
        this.uaObj.osType = CONSTS_OSTYPES.Android //android
      } else if (osName.indexOf('OS') > -1) {
        this.uaObj.osType = CONSTS_OSTYPES.IOS //ios
      } else {
        this.uaObj.osType = CONSTS_OSTYPES.Unknown //unknown
      }

      let versionStr = matches[0].split(' ')[1]
      let verStrP1 = versionStr.split('.')[0]
      this.uaObj.osVersion = verStrP1.split('_')[0]
    }
  },
  setCountry(contryCode) {
    H5Tracer.staticData.country = contryCode
  },
  setLanguage(lang) {
    H5Tracer.staticData.language = lang
  },
  /**
   * 马上执行埋点数据提交
   * @param { 事件名 } eventName
   * @param { 事件数据(userId/deviceId可以不用传) } data
   * @param { 事件类型 } category
   * @param { 使用所属应用 } appName
   * @param { 使用所属应用的版本 } appVersion
   * @param { 使用所属应用对应包名 } packageName
   */
  invoke(eventName, data, options) {
    data=data||{};
    options=options||{};
    
    options.category="scavengerhunt";
    options.appName="SkyVPN";
    options.appVersion="2.0.0";
    options.packageName="me.skyvpn.app";
    options.preferBeacon=false;

    const {
      category,
      appName,
      appVersion,
      packageName,
      label,
      value,
      preferBeacon
    } = options || {}
    let dtNow = Date.now()

    //1. 构造对象
    data.userId = localStorage.dot_userId
    data.deviceId = localStorage.dot_deviceId
    data.ua = navigator.userAgent
    data.url = window.location.href

    let msg = {
      events: [
        { 
          sessionid:
            'sid.' + String(dtNow) + Math.floor(Math.random() * 1000),
 
          userid: data.userId,
 
          deviceid: data.deviceId,

          country: H5Tracer.staticData.country || "IR",
          language: H5Tracer.staticData.language || "fa-IR",

          isp: '',
          idfa: 'idfa.' + localStorage.dot_userId,
          // bId: packageName,
          bid: packageName,

          appName: appName,
          appVersion: appVersion,
          osType: this.uaObj.osType,
          osVersion: this.uaObj.osVersion,

          timestamp: dtNow,
          data: {
            category: category,
            event: eventName,
            time: dtNow,
            label: label === undefined ? '' : label,
            value: value === undefined ? '' : value,
            index: 1,
            properties: data,
          },
        },
      ],
      version: 1,
    }

    //2. 计算sign
    let sign = ''
    let msgStr = JSON.stringify(msg)

    let myBuff = Buffer.from(msgStr, 'utf-8')
    if (myBuff.length > 128) {
      let newArr = []
      let buf1 = myBuff.slice(0, 64)
      for (let i = 0; i < buf1.length; i++) {
        newArr.push(buf1[i])
      }
      let buf2 = myBuff.slice(myBuff.length - 64)
      for (let i = 0; i < buf2.length; i++) {
        newArr.push(buf2[i])
      }
      sign = sha256.update(newArr).hex()
    } else {
      sign = sha256.update(myBuff).hex()
    }

    //3. 执行ajax
    const ajaxUrl = process.env.VUE_APP_ENV_DOTTING_API + '/report/log/async';
    const ajaxData = {
      topic: 'ANALYSE',
      msg: msgStr,
      sign: sign
    };
    console.log('=>', process.env.VUE_APP_ENV_DOTTING_API)
    //3. 执行ajax
    if (preferBeacon && supportSendBeacon) {
      navigator.sendBeacon(ajaxUrl, JSON.stringify(ajaxData));
    } else {
      ajaxTool.ajax({
        method: 'post',
        url: ajaxUrl,
        data: ajaxData,
        mimeType: 'application/json'
      });
    }
  },

  /**
   * 缓慢执行埋点数据提交
   * @param { 事件名 } eventName
   * @param { 事件数据(userId/deviceId可以不用传) } data
   * @param { 事件类型 } category
   * @param { 使用所属应用 } appName
   * @param { 使用所属应用的版本 } appVersion
   * @param { 使用所属应用对应包名 } packageName
   */
  lazyInvoke(eventName, data, category, appName, appVersion, packageName, label, value) {
    let dtNow = Date.now()
    //1. 存储
    //..........开始存储
    data.userId = localStorage.dot_userId
    data.deviceId = localStorage.dot_deviceId
    data.ua = navigator.userAgent
    data.url = window.location.href

    let events = []
    if (localStorage.dot_tranList) {
      events = JSON.parse(localStorage.dot_tranList)
    }
    events.push({
      // sessionId: localStorage.sessionId,
      sessionid: '',

      // userId: data.userId,
      userid: localStorage.dot_userId,

      // deviceId: localStorage.deviceId,
      deviceid: localStorage.dot_deviceId,

      country: H5Tracer.staticData.country,
      language: H5Tracer.staticData.language,

      isp: '',
      idfa: 'idfa.' + localStorage.dot_userId,
      // bId: packageName,
      bid: packageName,

      appName: appName,
      appVersion: appVersion,
      osType: this.uaObj.osType,
      osVersion: this.uaObj.osVersion,

      timestamp: dtNow,

      data: {
        category: category,
        event: eventName,
        time: dtNow,
        label: label === undefined ? label : '',
        value: value === undefined ? value : '',
        index: 1,
        properties: data,
      },
    })
    localStorage.dot_tranList = JSON.stringify(events)
    //..........结束存储

    //2. 执行
    if (localStorage.dot_interval) {
      return
    }

    localStorage.dot_interval = setInterval(() => {
      //2.1 判断是可以执行
      if (
        !localStorage.dot_tranList ||
        localStorage.dot_tranList == '{}' ||
        localStorage.dot_tranList == '[]'
      )
        return
      if (localStorage.dot_isExec) return
      localStorage.dot_isExec = true

      //2.2 节选前五个批量运行
      let evts = JSON.parse(localStorage.dot_tranList)
      let evts_exec = evts.splice(0, 5)
      let idstr = String(Date.now()) + Math.floor(Math.random() * 1000)
      for (let i = 0; i < evts_exec.length; i++) {
        evts_exec[i].sessionid = 'sid.' + idstr
      }

      //2.3 构造执行1 -> 计算sign
      let msgStr = JSON.stringify({
        events: evts_exec,
        version: 1,
      })
      let sign = ''
      let myBuff = Buffer.from(msgStr, 'utf-8')
      if (myBuff.length > 128) {
        let newArr = []
        let buf1 = myBuff.slice(0, 64)
        for (let i = 0; i < buf1.length; i++) {
          newArr.push(buf1[i])
        }
        let buf2 = myBuff.slice(myBuff.length - 64)
        for (let i = 0; i < buf2.length; i++) {
          newArr.push(buf2[i])
        }
        sign = sha256.update(newArr).hex()
      } else {
        sign = sha256.update(myBuff).hex()
      }

      //2.4 构造执行2 -> 执行ajax
      let prefix = process.env.VUE_APP_ENV_DOTTING_API
      ajaxTool.ajax({
        method: 'post',
        url: prefix + '/report/log',
        data: {
          topic: 'ANALYSE',
          msg: msgStr,
          sign: sign,
        },
        mimeType: 'application/json',
        callback: () => {
          //2.5 剩余存回
          localStorage.dot_tranList = JSON.stringify(evts)
          localStorage.dot_isExec = false
        },
      })
    }, 5000)
  },
}

H5Tracer.init();